import eventManger from '../utilities/EventManager';
import _ from 'lodash';

export const FIELD_TREE_EVENTS = {
  BACK_TO_MAIN: _.uniqueId('tree_back_to_main'), //メイン画面に戻る時にコール
  CONSTRUCTOR_EDIT: _.uniqueId('tree_constructor_edit'), //元請BOX編集
  COMPANY_EDIT: _.uniqueId('tree_company_edit'), //協力会社編集
  COMPANY_WORKER_ASSIGNATION: _.uniqueId('tree_company_worker_assignation'), //作業員割り当て
  COMPANY_DELETE: _.uniqueId('tree_company_delete'), //施工体制削除
  COMPANY_DELETE_SUCCESS: _.uniqueId('tree_company_delete_success'),
  COMPANY_DONE: _.uniqueId('tree_company_done'), //施工体制作業終了
  COMPANY_DONE_SUCCESS: _.uniqueId('tree_company_done'),
  COMPANY_DONE_CANCEL: _.uniqueId('tree_company_done_cancel'), //施工体制作業終了の取り消し
  NEW_BY_SEARCH: _.uniqueId('tree_new_by_search'), //検索から追加
  NEW_SEARCH: _.uniqueId('tree_new_search'), //協力会社を追加ダイアログ
  NEW_BY_FORM: _.uniqueId('tree_new_by_form'), //フォームから追加
  TREE_LOADED: _.uniqueId('tree_loaded'), // 体系図をロード
  TREE_REFRESH: _.uniqueId('tree_refresh'), // 体系図をリフレッシュする
  TREE_CONSTRUCTOR: _.uniqueId('tree_constructor'), //元請け名
  TREE_FIELD: _.uniqueId('tree_field'), //現場情報
  TREE_PAGINATION_DOWN: _.uniqueId('tree_field_pagination_down'), //ページネーション（前）
  TREE_PAGINATION_UP: _.uniqueId('tree_field_pagination_up'), //ページネーション（次）
  TREE_CLEAR_SEARCH_PARAM: _.uniqueId('tree_field_clear_search_param'), //絞りこみをクリア
  TREE_CLICK_OUTSIDE_TREE: _.uniqueId('tree_field_click_outside_tree'), //ツリーをクリック
  TREE_NEWMENU_REF: _.uniqueId('tree_newmenu_ref'), //新規メニューのRef取得
  TOGGLE_CCUS_STATES: _.uniqueId('toggle_ccus_states'), // CCUS連携状態の表示の切り替え
  TREE_ACCORDION_MENU_OPEN: _.uniqueId('tree_accordion_menu_open'), //アコーディオンメニューを開く
  SELECT_NODE: _.uniqueId('tree_select_node'),
  SHOW_EXIT_CONFIRM_DIALOG: _.uniqueId('show_exit_confirm_dialog'),
};

class Events {
  constructor() {
    for (let key in FIELD_TREE_EVENTS) {
      eventManger.registerEvent(FIELD_TREE_EVENTS[key]);
    }
  }
}

const FieldTreeEvents = new Events();
export default FieldTreeEvents;



// WEBPACK FOOTER //
// ./src/components/FieldTreeEvents.js